
const _draw = Symbol('_draw');

export default class ColourPencil{
	constructor() {
		// Constants.
		this.LINE_THICKNESS = 5;

		// Attributes.
		this._drawLayer = null;
		this._colour = null;
	}

	init(drawLayer){
		this._drawLayer = drawLayer;
	}

	onDrawBegan(point) {
		this[_draw](point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
	}

	onDrawMoved(from, to){
		this[_draw](from, to);
	}

	onDrawEnded(){
	}

	[_draw]( from, to ) {
		this._drawLayer.context.beginPath();
		this._drawLayer.context.strokeStyle = this._colour;
		this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
		this._drawLayer.context.lineJoin = 'round';
		this._drawLayer.context.moveTo( from.x, from.y );
		this._drawLayer.context.lineTo( to.x, to.y );
		this._drawLayer.context.closePath();
		this._drawLayer.context.stroke();

		this._drawLayer.onContext_Changed();
	}

	get colour(){
		return this._colour;
	}

	set colour(value){
		this._colour = value;
	}
}